export default "__VITE_ASSET__C78L9k9b__"